<script>
export default {
  name: 'TableSearch',
  props: {
    labelWidth: {
      default: ''
    }
  },
  data () {
    return {
      advanced: false,
    }
  },
  methods: {
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleSearch () {
      this.$emit('search')
    },
    handleReset () {
      this.$emit('reset')
    }
  },
  render () {
    const BasicForm = this.$slots.basic && this.$slots.basic.map(item => {
      const span = window.isNaN(item.data.attrs.span) ? 1 : Number(item.data.attrs.span)
      return (
        <el-col md={span * 8} sm={24}>
          {item}
        </el-col>
      )
    })

    const AdvancedFrom = this.$slots.advanced && this.$slots.advanced.map(item => {
      const span = window.isNaN(item.data.attrs.span) ? 1 : Number(item.data.attrs.span)
      return (
        <el-col md={span * 8} sm={24}>
          {item}
        </el-col>
      )
    })

    const Btns = this.$slots.btns && this.$slots.btns.map(item => {
      return (
        item
      )
    })

    return (
      <div class="table-page-search-wrapper">
        <el-form inline size="medium" labelWidth={this.labelWidth}>
          <el-row gutter={48}>
            {BasicForm}

            {this.advanced && AdvancedFrom}

            <el-col md={8} sm={24}>
              <el-form-item class="bottom-item">
                <span
                  class="table-page-search-submitButtons"
                  style={(this.advanced && { float: 'right', overflow: 'hidden' })}
                >
                  <el-button type="primary" onClick={this.handleSearch}>查询</el-button>
                  <el-button style="margin-left: 8px" onClick={this.handleReset}>重置</el-button>
                  {Btns}

                  {
                    AdvancedFrom &&
                    <a onClick={this.toggleAdvanced} style="margin-left: 8px">
                      { this.advanced ? '收起' : '展开' }
                      <i v-show={this.advanced} class="el-icon-caret-top"></i>
                      <i v-show={!this.advanced} class="el-icon-caret-bottom"></i>
                    </a>
                  }
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    )
  }
}
</script>

<style lang="scss">
.table-page-search-wrapper {
  background: white;
  .el-form--inline {
    padding: 24px;
    .el-form-item {
      display: flex;
      margin-bottom: 24px;
      margin-right: 0;

      .el-form-item__label {
        white-space: nowrap;
      }
      .el-form-item__content {
        flex: 1 1;
        display: inline-block;
        vertical-align: middle;

        height: 32px;
        line-height: 32px;
      }

      >.el-form-item__label {
        line-height: 32px;
        padding-right: 8px;
        color: #666666;
        width: auto;
      }

      .el-select {
        width: 100%;
      }
      .el-date-editor--timerange {
        min-width: 330px;
        width: 75%;
      }
    }
  }
  .bottom-item{
    margin-bottom: 0 !important;
  }
  .table-page-search-submitButtons {
    display: block;
    margin-bottom: 24px;
    white-space: nowrap;
  }

  // 单个日期选择器 加上 class = single - date
  .single-date .el-date-editor {
    width: 100%;
  }
  // 日期区间选择器
  .date-range .el-date-editor {
    width: 100%;
    min-width: 0; // 不知哪边设置了最小长度400
  }
}

</style>
